import { createClient } from '@/shared/api';
import DEVICE_EVENT_QUERY from '@/entities/strip/api/queries/deviceEventsV2';
import type { DeviceEvent } from '@/entities/strip/api/queries/deviceEventsV2';

export type DeviceEventsV2Result = {
  notificationEvents?: { events: DeviceEvent[] };
  patientTriggeredEvents?: { events: DeviceEvent[] };
  otherEvents?: { events: DeviceEvent[] };
};

// TODO(ts): typed as the DeviceEventsInput GraphQL input once its server-side shape is documented
/**
 * Loads device events matching a filter for the device management view. Creates an Apollo client honoring the cache flag and runs the key-suffixed device events query, returning its deviceEventsV2 field.
 *
 * @param filter - Server-side filter for the device events.
 * @param isUsingCache - Whether the Apollo client should serve from cache.
 * @param key - Suffix selecting the query variant; defaults to 0.
 * @returns A promise resolving to the deviceEventsV2 result.
 */
const fetchDeviceEvents = async (filter: any, isUsingCache?: boolean, key = 0) => {
  const client = await createClient(isUsingCache);
  const result = await client.query<{ deviceEventsV2: DeviceEventsV2Result }>({
    query: DEVICE_EVENT_QUERY(key),
    variables: {
      filter,
    },
  });
  const { data } = result || {};
  const { deviceEventsV2 } = data || {};
  // Returned verbatim (no field allowlist/destructure here), so every field the query
  // selects survives into formatDeviceEvent unchanged.
  return deviceEventsV2;
};

export default fetchDeviceEvents;
